import type {LucideIcon} from "lucide-react";
import {cn} from "@/lib/utils";
import {
  RESIDENT_HOME_ICON_ROW_CLASS,
  RESIDENT_HOME_ICON_WRAPPER_CLASS,
} from "@/src/modules/home/lib/resident-home-block-layout";

type ResidentHomeIconTextBlockProps = {
  icon: LucideIcon;
  iconWrapperClassName?: string;
  iconClassName?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
};

export function ResidentHomeIconTextBlock({
  icon: Icon,
  iconWrapperClassName,
  iconClassName,
  title,
  subtitle,
  className,
}: ResidentHomeIconTextBlockProps) {
  const multiline = subtitle != null;

  return (
    <div
      className={cn(
        RESIDENT_HOME_ICON_ROW_CLASS,
        multiline ? "items-start" : "items-center",
        className,
      )}
    >
      <div className={cn(RESIDENT_HOME_ICON_WRAPPER_CLASS, iconWrapperClassName)}>
        <Icon className={cn("text-primary size-4", iconClassName)} aria-hidden />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        {title}
        {subtitle}
      </div>
    </div>
  );
}
